import { render, staticRenderFns } from "./Formulaires.vue?vue&type=template&id=00ef3ad8&scoped=true&"
import script from "./Formulaires.vue?vue&type=script&lang=js&"
export * from "./Formulaires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ef3ad8",
  null
  
)

export default component.exports